var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{class:_vm.clazz,attrs:{"icon":['fas', 'shopping-cart'],"size":"1x"},on:{"click":function($event){return _vm.$emit('toggle')}}})}
var staticRenderFns = []

export { render, staticRenderFns }